var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{attrs:{"itemId":_vm.fileId},on:{"loaded":_vm.afterload}},[(!_vm.previewContent)?_c('a-spin',{staticClass:"office-view"},[_vm._v("正在加载中...")]):_c('vue-office-excel',{staticStyle:{"height":"calc(100vh - 0px)"},attrs:{"src":_vm.previewContent,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }